import { combineReducers } from "@reduxjs/toolkit";
import formatSlice from "./Slices/formatSlice";
import formatSectionSlice from "./Slices/formatSectionSlice";

export default combineReducers({
  format: formatSlice,
  formatSection: formatSectionSlice,
});
